<template>
    <div class="container-fluid">
        <b-card no-body class="my-2">
            <b-card-header class="">
                <b-card-title class="card-title-page-garden-help-default my-1">Find Contractors
                    <b-button variant="garden-help-filter" class="btn-bumblebee btn-garden-help float-right"
                        v-b-toggle.contractors-filter-sidebar><img
                            src="@/assets/images/garden-help/filter-action-icon.png" /></b-button>
                </b-card-title>
            </b-card-header>
        </b-card>
        <b-overlay :show="show_overlay" variant="success" :opacity=".5" rounded="sm" class="pb-3" style="min-height:100vh">
            <b-card no-body class="card-transparent-background find-contractor-garden-help-container my-1"
                v-if="contractors != null && contractors.length > 0">
                <b-card-body class="px-2">
                    <b-row cols="1" cols-sm="2" cols-lg="3" :cols-xl="cols_num_xl">
                        <b-col class="my-2 px-2" v-for="contractor in contractors" :key="contractor.id">
                            <!-- <router-link :to="'/garden_help/jobs/view_job/' + contractor.id"> -->
                                <ContractorCardFindContractors :contractor="contractor" />
                            <!-- </router-link> -->
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>
            <b-card no-body class="card-transparent-background find-contractor-garden-help-container my-1" v-else>
                <b-card-body class="px-2">
                    <b-row>
                        <b-col>
                            <p class="no-results-p-garden-help">No results found</p>
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>


            <!-- pagination -->
            <b-card class="card-transparent-background m-0 mb-3" no-body>
                <b-card-body class="px-2 py-0">
                    <b-row cols="1" cols-md="2">
                        <b-col>
                            <p class="data-list-info-garden-help">
                                Showing {{ from_page }} to {{ to_page }} of
                                {{ total_items }} entries
                            </p>
                        </b-col>
                        <b-col>
                            <b-pagination class="pagination-garden-help" v-model="currentPage" :total-rows="total_items"
                                :per-page="perPage" limit="7" @change="changePage" size="md"></b-pagination></b-col>
                    </b-row>
                </b-card-body>
            </b-card>
        </b-overlay>
        <!-- filter sidebar -->
        <b-sidebar id="contractors-filter-sidebar" class="filter-sidebar-garden-help" title="Sidebar" right shadow
            ref="sidebar_filter" :no-close-on-backdrop="false" :backdrop="true">
            <div class="px-3 py-2">
                <InputCheckboxFilter field_label="Service Categories" :options="servies_list"
                    :field_model.sync="service_filter" />

                <!-- <b-form-group label="Distance" label-for="fulfilment_date" label-class="form-label-filter-garden-help text-left ">
            <vue-slider class="vue-slider-garden-help mt-3" v-model="distance" :min="0" :max="60" :interval="1"
              :dotSize="[22, 22]" height="8px" tooltip="always" :tooltip-formatter="'{value}km'"></vue-slider>
          </b-form-group> -->

                <InputCheckboxFilter field_label="Experience Level" :options="experience_levels_list"
                    :field_model.sync="experience_level_filter" />

            </div>

            <template #header="{ hide }">
                <b-row class="w-100">
                    <b-col cols="10">
                        <h2 class="filter-header w-100">
                            <img src="@/assets/images/garden-help/filter-icon.png" /> Filter
                        </h2>
                    </b-col>
                    <b-col cols="2" class="px-0" align-self="center">
                        <b-button variant="garden-help-info-light" class="
                                      btn-bumblebee btn-garden-help btn-close-action
                                      d-block
                                      float-right
                                      m-auto
                                    " @click="hide">x</b-button></b-col>
                </b-row>
            </template>
            <template #footer>
                <b-row class="p-2 w-100 m-auto" cols="2">
                    <b-col>
                        <b-button variant="garden-help-primary" class="btn-bumblebee btn-garden-help"
                            @click="clickFilter">Filter</b-button>
                    </b-col>
                    <b-col>
                        <b-button variant="garden-help-light-outline" class="btn-bumblebee btn-garden-help"
                            @click="clickClearFilters">Clear All</b-button>
                    </b-col>
                </b-row>
            </template>
        </b-sidebar>
    </div>
</template>
  
          
<script>
import axios from "axios";
import $ from "jquery";
import ContractorCardFindContractors from "./contractor_card/FindContractor.vue"
import InputCheckboxFilter from "../components/InputCheckboxFilter.vue";

import {
    listServicesRequest,
    listExperienceLevels,
    listPropertyTypes,
} from "@/utils/helper-functions-garden-help.js";

export default {
    name: "GardenHelpFindContractors",
    components: { ContractorCardFindContractors, InputCheckboxFilter },
    data() {
        return {
            windowWidth: window.innerWidth,
            show_overlay: false,
            client_name: "GARDENHELP",
            cols_num_xl: 3,
            contractors: [
                {
                    "id": 5,
                    "first_name": "Bumblebee",
                    "last_name": "Contractor",
                    "client": "GARDENHELP",
                    "name": "Bumblebee Contractor",
                }
            ],
            // pagination
            perPage: 12,
            currentPage: 1,
            total_items: 0,
            from_page: 0,
            to_page: 0,
            // filter data
            servies_list: [],
            service_filter: [],
            experience_levels_list: [],
            experience_level_filter: [],
        };
    },
    mounted() {
        this.show_overlay = true
          this.getContractorsList()

        if (window.innerWidth >= 2000) {
            this.cols_num_xl = 5;
        } else {
            this.cols_num_xl = 3;
        }
        window.addEventListener("resize", () => {
            this.windowWidth = window.innerWidth;
            if (window.innerWidth >= 2000) {
                this.cols_num_xl = 5;
            } else {
                this.cols_num_xl = 3;
            }
        });

        //
        console.log(this.listServicesRequest(null));
        this.getFilterData();
    },
    methods: {
        listServicesRequest,
        listExperienceLevels,
        listPropertyTypes,
        async getFilterData() {
            this.experience_levels_list = this.listExperienceLevels();

            this.servies_list = await this.listServicesRequest(null);
        },
        changePage(value) {
            console.log("change page", value);
            this.currentPage = value
            console.log(this.currentPage)
            this.getContractorsList()
        },
        clickClearFilters() {
            this.service_filter = [];
            this.experience_level_filter = [];
        },
        clickFilter() {
            console.log("click filter")
            this.currentPage = 1

            console.log("Service", this.service_filter)
            console.log("experience", this.experience_level_filter)


            console.log(this.$refs.sidebar_filter)
            this.$refs.sidebar_filter.hide()
            this.getContractorsList()
        },
        getContractorsList() {
            this.show_overlay = true
            console.log(this.currentPage)
            let params_request = "?per_page=" + this.perPage + "&page=" + this.currentPage;
            console.log(params_request)

            if (this.service_filter.length > 0) {
                params_request += "&services=" + this.service_filter.toString()
            }
            if(this.experience_level_filter.length > 0){
                let selected_experience = this.experience_level_filter.toString()

                params_request += "&experience_level="+encodeURIComponent(selected_experience)
            }

            console.log(params_request)

            axios
                .get("/operator/contractors-list" + params_request, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    console.log(response.data)
                    console.log(response)
                    this.contractors = response.data.data;

                    this.total_items = response.data.meta.total
                    if (response.data.meta.total == 0) {
                        this.from_page = 0
                        this.to_page = 0
                    } else {
                        this.from_page = ((this.currentPage - 1) * this.perPage) + 1
                        this.to_page = this.currentPage * this.perPage > response.data.meta.total ? response.data.meta.total : this.currentPage * this.perPage
                    }
                    this.show_overlay = false
                });
        }
    },
};
</script>
<style scoped::v-deep >@import "../styles/garden-help-button-styles.css";
@import "../styles/garden-help-styles.css";</style>


// WEBPACK FOOTER //
// src/projects/garden_help/contractor/FindContractors.vue